<template>
  <b-col lg="6">
    <b-form ref="userGroupTestMethodForm" class="needs-validation" @submit="onSubmit" @reset="onReset">
      <EasyDataTable
        :headers="fields"
        :items="testMethodsModified"
        :alternating="true"
        :rows-per-page="10000"
        :hide-rows-per-page="true"
      >
        <template #item-isForTestBuilder="item">
          <span v-show="item.isForTestBuilder" class="fa fa-check"></span>
        </template>
        <template #expand="item">
          <EasyDataTable
            :headers="normGroupFields"
            :items="item.normGroups"
            :rows-per-page="10000"
            :hide-rows-per-page="true"
          >
            <template #item-selected="subitem">
              <input type="checkbox" v-model="subitem.selected" @click="onChangeSelected(item, subitem)" />
            </template>
          </EasyDataTable>
        </template>
      </EasyDataTable>

      <b-form-group class="mt-2">
        <b-button type="submit" class="me-1">{{ $t('save') }}</b-button>
        <b-button type="reset" variant="danger">{{ $t('cancel') }}</b-button>
      </b-form-group>

    </b-form>
  </b-col>
</template>

<script>
import NormGroupTable from '../normgroups/normgrouptable'

export default {
  name: 'user-group-test-method-selector',
  components: {
    NormGroupTable
  },
  props: {
    testMethods: {},
    allowEdit: false,
    isSupplierCompany: false
  },
  data() {
    return {
      testMethodsModified: this.testMethods || []
    }
  },
  watch: {
    testMethods() {
      if (this.testMethods !== this.testMethodsModified) {
        this.testMethodsModified = this.testMethods
      }
    }
  },
  computed: {
    fields() {
      return [
        { value: 'name', text: this.$t('name') },
        {
          value: 'isForTestBuilder',
          text: this.$t('privatePage.isUsedForTestBuilder_label'),
          sortable: true
        },
        { value: 'show_details', text: ' ' }
      ]
    },
    normGroupFields() {
      let f = [
        {
          value: 'name',
          text: this.$t('privatePage.normgroup'),
          sortable: true
        }
      ]

      if (!this.isSupplierCompany) {
        f.push({
          value: 'selected',
          text: this.$t('privatePage.isActive'),
          sortable: true,
          thClass: 'rightAlignedField',
          tdClass: 'rightAlignedField'
        })
      }
      return f
    }
  },
  methods: {
    onChangeSelected: function(testmethod, normgroup) {
      const newTestMethods = this.testMethodsModified.map(i => {
        if (i.id === testmethod.id) {
          let normgroups = i.normGroups.map(n => {
            if (n.normGroupId === normgroup.normGroupId) {
              const newSelected = !n.selected
              return { ...n, selected: newSelected }
            }
            return n
          })
          return { ...i, normGroups: normgroups }
        }
        return i
      })
      this.testMethodsModified = newTestMethods
    },
    onSubmit: function(evt) {
      // let testMethodNormScaleValueIds = []

      // this.testMethods.forEach(testMethod => {
      //   testMethod.normGroups.forEach(normGroup => {
      //     if (normGroup.selected) {
      //       testMethodNormScaleValueIds.push(
      //         normGroup.testMethodNormScaleValueId
      //       )
      //     }
      //   })
      // })
      // this.$emit('onSubmit', testMethodNormScaleValueIds)
      this.$emit('onSubmit', this.testMethodsModified)
    },
    onReset: function(evt) {
      evt.preventDefault()
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.table-hover tbody tr:hover {
  background-color: #fff !important;
}
.table td {
  padding: 0px !important;
}
.rowAlignRight {
  text-align: right !important;
}
</style>
